import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator } from './components/sliders.js';

document.addEventListener("DOMContentLoaded", function () {
  slickSliderGenerator('products', '.products-container');
  getSVG();
});
